var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "15", height: "12.323", viewBox: "0 0 15 12.323" }, props),
    React.createElement("circle", { className: styles["a"] || "a", cx: "1.612", cy: "1.612", r: "1.612", transform: "translate(5.888 9.099)" }),
    React.createElement("path", { className: styles["a"] || "a", d: "M10.347 7.76a4.03 4.03 0 0 0-5.693 0L3.269 6.375a5.991 5.991 0 0 1 8.463 0z" }),
    React.createElement("path", { className: styles["a"] || "a", d: "M1.385 4.492L0 3.107a10.607 10.607 0 0 1 15 0l-1.385 1.385a8.648 8.648 0 0 0-12.229 0z" })
  );
});